import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { jobEndpoints, appointmentAuthEndpoints } from '@/lib/api/endpoints';
import { jobKeys, isJobAppointmentsQuery } from '@/lib/queryKeys';
import type { SignoffMethod } from '@/types/job';

export interface CollectSignoffDto {
  method: SignoffMethod;
  signedByName: string;
  signatureUrl?: string;
  ipAddress?: string;
  satisfactionRating?: number;
  notes?: string;
}

export function useCollectSignoff(entity: 'job' | 'appointment' = 'job') {
  const qc = useQueryClient();
  return useApiMutation<unknown, CollectSignoffDto & { id: string }>({
    mutationFn: ({ id, ...dto }) => {
      const url =
        entity === 'job'
          ? jobEndpoints.signoffCollect(id)
          : appointmentAuthEndpoints.signoffCollect(id);
      return apiPost(operationsClient, url, dto);
    },
    onSuccess: (_data, vars) => {
      if (entity === 'job') {
        void qc.invalidateQueries({ queryKey: jobKeys.detail(vars.id) });
      } else {
        // The mutation only carries the appointment id, not its jobId, so match
        // any cached job-appointments list/detail query and refetch it.
        void qc.invalidateQueries({ predicate: isJobAppointmentsQuery });
      }
      toast.success('Sign-off recorded');
    },
  });
}
